<script setup lang="ts">
import { ref } from "vue";

defineProps<{
    isLoggedIn: boolean;
    user?: {
        first_name?: string;
        surname?: string;
        email?: string;
    } | null;
}>();

defineEmits<{
    logout: [];
}>();

const isHidden = ref(false);

function hideAndRun(action?: () => void) {
    if (isHidden.value) return;

    isHidden.value = true;

    action?.();

    window.setTimeout(() => {
        isHidden.value = false;
    }, 500);
}
</script>

<template>
    <div
        class="z-10 flex flex-col overflow-hidden transition-[opacity] duration-200 ease-in-out lg:absolute lg:top-[43px] lg:flex-row lg:gap-8 lg:rounded-xl lg:border-[1px] border-component-divider-default bg-background-body lg:p-4 lg:opacity-0 lg:shadow-[0px_16px_32px_8px_rgba(0,0,0,0.12)] group-[.scrolled]/header:lg:top-[43px]"
        role="menu"
        :class="isHidden ? '!hidden' : ''"
    >
        <div class="flex flex-col">
            <div
                class="mb-2 text-[14px] font-semibold leading-[20px] text-link-primary-default"
            >
                {{ user?.first_name }}
                {{ user?.surname }}
            </div>

            <div class="text-[12px] leading-[16px] text-text-subtle">
                {{ user?.email }}
            </div>

            <div
                class="my-4 h-[1px] w-[200px] bg-component-divider-default"
            ></div>

            <div class="flex flex-col gap-4">
                <RouterLink
                    class="text-[14px] font-semibold leading-[20px] no-underline hover:underline"
                    to="/account"
                    @click="hideAndRun()"
                >
                    {{ $t("menu.myAccount") }}
                </RouterLink>

                <a
                    href="#"
                    class="text-[14px] font-semibold leading-[20px] no-underline hover:underline text-functional-error"
                    @click.prevent="$emit('logout')"
                >
                    {{ $t("menu.logout") }}
                </a>
            </div>
        </div>
    </div>
</template>
